/**
 * Custom History object to be used as a singleton throughout
 * the project to navigate between pages
 */
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
